"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationContainer = exports.StyledPagination = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "prefixCls", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledPagination, (0, _extends2.default)({
    $size: size,
    prefixCls: prefix
  }, rest), children(prefix));
};
var StyledPagination = exports.StyledPagination = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-do6ie-0"
})([".", "{font-size:", ";user-select:none;padding:0;margin:0px;> li{list-style:none;&:focus{outline:none;}}&-total-text{float:left;height:", ";line-height:", ";list-style:none;padding:0;margin:0 8px 0 0;font-size:", ";}&:after{content:' ';display:block;height:0;clear:both;overflow:hidden;visibility:hidden;}&-item{cursor:pointer;border-radius:4px;min-width:", ";height:", ";line-height:calc(", " - 1px);text-align:center;list-style:none;float:left;border:1px solid ", ";background-color:#fff;margin:3px 4px 3px 0;a{text-decoration:none;color:", ";font-size:", ";line-height:23px;}&:hover{a{color:", ";}}&-active{background-color:", ";border-color:", ";a{color:", ";}&:hover{a{color:", ";}}}}&-jump-prev,&-jump-next{&:after{content:'\u2022\u2022\u2022';display:block;letter-spacing:2px;color:", ";font-size:", ";margin-top:1px;}&:hover{", "{color:", ";}}}&-jump-prev{", "{display:none;}&:hover{", "{display:inline-block;vertical-align:middle;}&:after{display:none;}}}&-jump-next{", "{display:none;}&:hover{", "{display:inline-block;vertical-align:middle;}&:after{display:none;}}}&-prev,&-next,&-jump-prev,&-jump-next{cursor:pointer;color:", ";font-size:10px;border-radius:4px;list-style:none;min-width:", ";height:", ";line-height:", ";float:left;text-align:center;margin:3px 4px 3px 0;", "{vertical-align:baseline;}}&-next{margin:3px 0px;}&-prev,&-next{border:1px solid ", ";font-size:18px;a{color:", ";", "{color:", ";margin-top:2px;}}&:hover{border-color:", ";background:", ";a{color:", ";", "{color:", ";}}}&:active{border-color:", ";background:", ";a{", "{color:", ";}}}}&-disabled{cursor:not-allowed;border-color:", ";a{color:", ";", "{color:", ";}}&:hover{border-color:", ";a{color:", ";", "{color:", ";}}}}&-options{float:left;margin-left:20px;&-size-changer{float:left;width:80px;}&-quick-jumper{float:left;height:30px;line-height:30px;input{margin:0 10px;box-sizing:border-box;background-color:#fff;border-radius:6px;border:1px solid #d9d9d9;outline:none;padding:3px 12px;width:50px;height:30px;&:hover{border-color:", ";}}button{display:inline-block;margin:0 8px;font-weight:500;text-align:center;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:0 15px;font-size:12px;border-radius:6px;height:28px;user-select:none;transition:all 0.3s cubic-bezier(0.645,0.045,0.355,1);position:relative;color:rgba(0,0,0,0.65);background-color:#fff;border-color:#d9d9d9;&:hover,&:active,&:focus{color:", ";background-color:#fff;border-color:", ";}}}}&-simple{[class$='-prev'],[class$='-next']{border:none;height:24px;line-height:24px;margin:0;font-size:18px;}[class$='-simple-pager']{float:left;margin-right:8px;list-style:none;[class$='-slash']{margin:0 10px;}input{margin:0 8px;box-sizing:border-box;background-color:#fff;border-radius:4px;border:1px solid #d9d9d9;outline:none;padding:5px 8px;min-height:20px;&:hover{border-color:", ";}}button{display:inline-block;margin:0 8px;font-weight:500;text-align:center;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:0 8px;font-size:12px;border-radius:4px;height:26px;user-select:none;transition:all 0.3s cubic-bezier(0.645,0.045,0.355,1);position:relative;color:rgba(0,0,0,0.65);background-color:#fff;border-color:#d9d9d9;&:hover,&:active,&:focus{color:#2db7f5;background-color:#fff;border-color:#2db7f5;}}}}", " ", " @media only screen and (max-width:1024px){&-item{&-after-jump-prev,&-before-jump-next{display:none;}}}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.font.sizeSm;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.theme.pagination.itemFontSize;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.bordered ? props.theme.pagination.borderColor : 'transparent';
}, function (props) {
  return props.theme.pagination.itemTextColor.default;
}, function (props) {
  return props.theme.pagination.itemFontSize;
}, function (props) {
  return props.theme.pagination.itemTextColor.hover;
}, function (props) {
  return props.theme.pagination.itemActiveColor;
}, function (props) {
  return props.theme.pagination.itemActiveColor;
}, function (props) {
  return props.theme.pagination.itemTextColor.select;
}, function (props) {
  return props.theme.pagination.itemTextColor.select;
}, function (props) {
  return props.theme.color.grey6;
}, function (props) {
  return props.theme.font.sizeSm;
}, _StyledIcon.default, function (props) {
  return props.theme.pagination.itemHoverColor;
}, _StyledIcon.default, _StyledIcon.default, _StyledIcon.default, _StyledIcon.default, function (props) {
  return props.theme.pagination.itemColor;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.theme.pagination.itemSize;
}, function (props) {
  return props.theme.pagination.itemSize;
}, _StyledIcon.default, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, _StyledIcon.default, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary5;
}, function (props) {
  return props.theme.color.primary1;
}, function (props) {
  return props.theme.color.primary6;
}, _StyledIcon.default, function (props) {
  return props.theme.color.primary5;
}, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.theme.color.primary2;
}, _StyledIcon.default, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.theme.pagination.disabledBorderColor;
}, function (props) {
  return props.theme.pagination.disabledTextColor;
}, _StyledIcon.default, function (props) {
  return props.theme.pagination.disabledIconColor;
}, function (props) {
  return props.theme.pagination.disabledBorderColor;
}, function (props) {
  return props.theme.pagination.disabledTextColor;
}, _StyledIcon.default, function (props) {
  return props.theme.pagination.disabledIconColor;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.$size == 'small' && (0, _ykbStyledComponents.css)(["&-total-text{height:", ";line-height:", ";}&-simple-pager{height:", ";line-height:", ";}&-item{min-width:", ";height:", ";margin:0 3px 0 0;line-height:", ";&:not([class$='-item-active']){background:transparent;border-color:transparent;}a{line-height:21px;}}&-prev{margin:0;margin-right:3px;min-width:", ";height:", ";line-height:", ";[class$='-item-link']{background:transparent;border-color:transparent;&::after{height:", ";line-height:", ";}}}&-next{min-width:", ";height:", ";margin:0;line-height:", ";[class$='-item-link']{background:transparent;border-color:transparent;&::after{height:", ";line-height:", ";}}}&-jump-prev{height:", ";margin-right:0;line-height:", ";}&-jump-next{height:", ";margin-right:0;line-height:", ";}&-options{&-size-changer{top:", ";}&-quick-jumper{height:", ";line-height:", ";input{padding:", " ", ";height:", ";width:44px;}}}"], function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.smallItemLineHeight;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.miniOptionsSizeChangerTop;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.pagination.itemSizeSm;
  }, function (props) {
    return props.theme.input.sizes.small.paddingVertical;
  }, function (props) {
    return props.theme.input.sizes.small.paddingHorizontal;
  }, function (props) {
    return props.theme.input.sizes.small.height;
  });
}, function (props) {
  return props.$size == 'large' && (0, _ykbStyledComponents.css)(["&-total-text{height:", ";line-height:", ";}&-simple-pager{height:", ";line-height:", ";}&-item{min-width:", ";height:", ";margin:0 4px 0 0;line-height:", ";&:not([class$='-item-active']){background:transparent;border-color:transparent;}}&-prev{margin:0;margin-right:4px;min-width:", ";height:", ";line-height:", ";[class$='-item-link']{background:transparent;border-color:transparent;&::after{height:", ";line-height:", ";}}}&-next{min-width:", ";height:", ";margin:0;line-height:", ";[class$='-item-link']{background:transparent;border-color:transparent;&::after{height:", ";line-height:", ";}}}&-jump-prev{height:", ";margin-right:4px;line-height:", ";}&-jump-next{height:", ";margin-right:4px;line-height:", ";}&-options{&-size-changer{top:", ";}&-quick-jumper{height:", ";line-height:", ";input{padding:", " ", ";height:", ";width:44px;}}}"], function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.largeItemLineHeight;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.jumpHeightLg;
  }, function (props) {
    return props.theme.pagination.jumpHeightLg;
  }, function (props) {
    return props.theme.pagination.jumpHeightLg;
  }, function (props) {
    return props.theme.pagination.jumpHeightLg;
  }, function (props) {
    return props.theme.pagination.miniOptionsSizeChangerTop;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.pagination.itemSizeLg;
  }, function (props) {
    return props.theme.input.sizes.small.paddingVertical;
  }, function (props) {
    return props.theme.input.sizes.small.paddingHorizontal;
  }, function (props) {
    return props.theme.input.sizes.small.height;
  });
});
var StyledPaginationContainer = exports.StyledPaginationContainer = (0, _ykbStyledComponents.default)(StyledContainer).withConfig({
  componentId: "ykb-ui__sc-do6ie-1"
})([""]);